// src/pages/pedidos/CadPedido.js
import { formatarVariacoes } from '../../utils/VariacaoUtils';
import React, { useEffect, useMemo, useRef, useState } from "react";
import Input from "../../components/input/Input";
import InputCheck from "../../components/input/InputCheck";
import Select from "../../components/input/Select";
import { formatCurrency, parseNumeric } from "../../utils/numberUtils";
import ModalContainer from "../../components/modalForm/ModalContainer";
import ModalHeader from "../../components/modalForm/ModalHeader";
import ModalBody from "../../components/modalForm/ModalBody";
import ModalFooter from "../../components/modalForm/ModalFooter";
import { Pedido } from "../../models/pedidos/Pedido";
import { TaxaEntregaBairro } from "../../models/pedidos/TaxaEntregaBairro";
import { PedidoItem } from "../../models/pedidos/PedidoItem";
import { usePedidoItem } from "../../contexts/pedidos/PedidoItemContext";
import { useMessage } from '../../contexts/geral/MessageContext';
import { useYesNo } from '../../contexts/geral/YesNoContext';
import { useTiposEntrega } from "../../contexts/pedidos/TiposEntregaContext";
import { useTaxaEntrega } from "../../contexts/pedidos/TaxaEntregaContext";
import { useTaxaEntregaBairro } from "../../contexts/pedidos/TaxaEntregaBairroContext";
import { usePedido } from "../../contexts/pedidos/PedidoContext";
import { useConfigPedido } from "../../contexts/pedidos/ConfigPedidoContext";
import InputCliente from "../../components/input/InputCliente";
import { useCliente } from "../../contexts/pessoas/ClienteContext";
import { usePrinter } from "../../contexts/geral/PrinterContext";
import { useConfigModulo } from "../../contexts/administrativo/ConfigModuloContext";

import AddItemPedidoModal from "./AddItemPedidoModal";
import AjusteValorPedidoModal from "./AjusteValorPedidoModal";
import EnderecoPedidoModal from "./EnderecoPedidoModal";
import { useProduto } from "../../contexts/produtos/ProdutoContext";

import { FaDollarSign, FaEdit, FaTrashAlt } from "react-icons/fa";
import { FiClipboard, FiShoppingBag, FiUser, FiTruck, FiCreditCard, FiMessageSquare, FiMapPin, FiEdit2, FiPlus } from "react-icons/fi";

import "./CadPedido.css"; // ✅ novo (escopado)
import ModalTable from "../../components/modalForm/ModalTable";
import ModalActions, { ModalActionButton } from "../../components/modalForm/ModalActions";
import { checkWhatsNumber } from "../../contexts/pedidos/WhatsappWebContext";
import { getNumeroPedido } from "../../utils/pedidoUtils";
import { comporEnderecoCliente, decomporEnderecoCliente, enderecoPessoaParaCampos } from "../../utils/enderecoUtils";
import { StatusPedido, getStatusPedidoDescricao, statusPedidoOptions } from "../../models/pedidos/StatusPedido";
import { createPedido, updatePedidoService, enviarAlteracaoPedidoWhats, salvarPedidoGarcom } from "../../services/pedidos/PedidoService";
import { useAlert } from "../../contexts/geral/AlertContext";

const omitirCampos = (objeto, campos) => Object.fromEntries(
  Object.entries(objeto || {}).filter(([campo]) => !campos.includes(campo))
);

const prepararPedidoItemPayload = (item) => ({
  ...omitirCampos(item, ["produto", "tempId"]),
  produtoId: Number(item?.produtoId || item?.produto?.id || 0),
  pedidoItemAdicionais: (item?.pedidoItemAdicionais || []).map((adicional) =>
    omitirCampos(adicional, ["adicional", "tempId"])
  ),
  pedidoItemConjuntos: (item?.pedidoItemConjuntos || []).map((conjunto) =>
    omitirCampos(conjunto, ["produto", "conjuntoItem", "tempId"])
  ),
});

const coresStatusPedido = {
  [StatusPedido.Cancelado]: 'red',
  [StatusPedido.EmAnalise]: 'red',
  [StatusPedido.EmProducao]: 'yellow',
  [StatusPedido.AguardandoRetiradaEntrega]: 'blue',
  [StatusPedido.Concluido]: 'green',
};


function CadPedido({ isOpen, onClose, pedidoComanda = false, pedidoAvulso = false, produtoInicialPedido = null }) {
  const { showMessage } = useMessage();
  const { showAlert } = useAlert();
  const { showYesNo } = useYesNo();
  const {
    printPedidoPDFById,
    // printReciboPedido,
  } = usePrinter();
  const { configPedido } = useConfigPedido();  
  const { pedidoSel, setPedidoSel } = usePedido();  
  const { pedidoItens, setPedidoItemSel, fetchPedidoItens, setPedidoItens, deletePedidoItem } = usePedidoItem();
  const { showClienteCad, clientes, buscaClientes, getClienteByTelefone, aplicarEnderecoCliente } = useCliente();
  const { taxaEntregaDefault } = useTaxaEntrega();
  const { taxasEntregaBairro } = useTaxaEntregaBairro();
  const { tiposEntrega } = useTiposEntrega();
  const { configModuloSel } = useConfigModulo();
  const headerColors = { backgroundColor: configModuloSel?.corApp, textColor: configModuloSel?.corFonteApp };
  const [erros, setErros] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isApplyingEndereco, setIsApplyingEndereco] = useState(false);
  const [erroAplicacaoEndereco, setErroAplicacaoEndereco] = useState('');
  const aplicandoEnderecoRef = useRef(false);
  const [agendadoPara, setAgendadoPara] = useState(false);
  const [enderecoCampos, setEnderecoCampos] = useState({
    logradouro: '',
    numero: '',
    bairro: '',
    complemento: '',
  });

  const { showProdutoSearch } = useProduto();

  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [showAjusteValorModal, setShowAjusteValorModal] = useState(false);
  const [showEnderecoModal, setShowEnderecoModal] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const clienteEnderecoRef = useRef(null);
  const bairroEnderecoRef = useRef(null);
  const versaoClienteRef = useRef(0);
  const [pedidoSalvoResponse, setPedidoSalvoResponse] = useState(null);
  const pedidoGravadoRef = useRef(false);
  const formularioRef = useRef(null);
  const cabecalhoFormularioRef = useRef(null);
  const focarErroAoSalvarRef = useRef(false);

  useEffect(() => {
    if (!isOpen || showEnderecoModal || !focarErroAoSalvarRef.current) return;
    focarErroAoSalvarRef.current = false;
    const campo = [cabecalhoFormularioRef.current, formularioRef.current]
      .flatMap((formulario) => Array.from(formulario?.querySelectorAll('[aria-invalid="true"]') || []))
      .find((elemento) => {
        if (elemento.matches(':disabled') || elemento.closest('[hidden], [inert]')) return false;
        for (let ancestral = elemento; ancestral; ancestral = ancestral.parentElement) {
          const estilo = window.getComputedStyle(ancestral);
          if (estilo.display === 'none' || estilo.visibility === 'hidden') return false;
        }
        return true;
      });
    campo?.focus({ preventScroll: true });
    campo?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  }, [erros, isOpen, showEnderecoModal]);

  const iniciarEnderecoCliente = (campos, cliente = null) => {
    versaoClienteRef.current += 1;
    clienteEnderecoRef.current = cliente;
    setEnderecoCampos(campos);
    setShowEnderecoModal(false);
    setErroAplicacaoEndereco('');
    setErros((anterior) => ({ ...anterior, logradouro: '', numero: '', bairro: '', taxaEntregaBairroId: '', enderecoCliente: '' }));
  };

  const fecharPedido = () => { if (!isSaving && !aplicandoEnderecoRef.current) onClose(pedidoSalvoResponse || undefined); };
  const fecharEndereco = () => {
    if (aplicandoEnderecoRef.current) return;
    setShowEnderecoModal(false);
    setErroAplicacaoEndereco('');
  };

  // ✅ NOVO: item que está sendo editado
  const [pedidoItemEditando, setPedidoItemEditando] = useState(null);
  const [autoOpenItemModal, setAutoOpenItemModal] = useState(false);

  const isEdit = !!pedidoSel?.id && pedidoSel.id !== 0; 

  const formatEnderecoCliente = (endereco) => {
    return comporEnderecoCliente(enderecoPessoaParaCampos(endereco));
  };

  const handleAplicarEndereco = async (dados) => {
    if (aplicandoEnderecoRef.current || isSaving) return;
    aplicandoEnderecoRef.current = true;
    versaoClienteRef.current += 1;
    setIsApplyingEndereco(true);
    setErroAplicacaoEndereco('');
    const campos = enderecoPessoaParaCampos(dados);
    try {
      const cliente = await aplicarEnderecoCliente({
        clienteId: pedidoSel.clienteId,
        telefoneCliente: pedidoSel.telefoneCliente,
        enderecoInicial: enderecoCampos,
        enderecoAtual: campos,
        cidadeId: taxasEntregaBairro.find(t => Number(t.id) === Number(dados.taxaEntregaBairroId))?.cidadeId,
      });
      clienteEnderecoRef.current = cliente;
      setEnderecoCampos(campos);
      bairroEnderecoRef.current = dados.taxaEntregaBairroId;
      setPedidoSel((anterior) => ({
        ...anterior,
        clienteId: cliente?.id || anterior.clienteId,
        enderecoCliente: comporEnderecoCliente(campos),
        taxaEntregaBairroId: dados.taxaEntregaBairroId,
        taxaEntrega: dados.taxaEntrega,
      }));
      setErros((anterior) => ({ ...anterior, logradouro: '', numero: '', bairro: '', taxaEntregaBairroId: '', enderecoCliente: '' }));
      focarErroAoSalvarRef.current = false;
      setShowEnderecoModal(false);
    } catch (error) {
      setErroAplicacaoEndereco(error?.message || 'Não foi possível salvar o endereço do cliente. Tente novamente.');
    } finally {
      aplicandoEnderecoRef.current = false;
      setIsApplyingEndereco(false);
    }
  };

  const formatHoraPrevisao = (dataHoraPrevisao) => {
    if (!dataHoraPrevisao) return '';

    const data = new Date(dataHoraPrevisao);

    if (Number.isNaN(data.getTime())) return '';

    const hours = String(data.getHours()).padStart(2, '0');
    const minutes = String(data.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
  };

  useEffect(() => {
    let ativo = true;
    const carregarDados = async () => {
      if (isOpen) {
        bairroEnderecoRef.current = pedidoSel.taxaEntregaBairroId || null;
        pedidoGravadoRef.current = false;
        setPedidoSalvoResponse(null);
        if (pedidoSel.id === 0) {
          let pedidoData = new Pedido();
          pedidoData.statusPedido = pedidoAvulso ? StatusPedido.Concluido : StatusPedido.EmProducao; // Avulso conclui direto; demais entram em produção

          if (pedidoComanda) {
            pedidoData.tipoEntregaId = 3;
            pedidoData.formaPagId = null;
          } else {
            pedidoData.tipoEntregaId = 1;
            pedidoData.formaPagId = 1;
          }

          pedidoData.nomeCliente = pedidoSel.nomeCliente || '';
          pedidoData.telefoneCliente = pedidoSel.telefoneCliente || '';
          pedidoData.enderecoCliente = pedidoSel.enderecoCliente || '';
          pedidoData.clienteId = pedidoSel.clienteId || null;
          pedidoData.comandaId = pedidoSel.comandaId || null;

          let now = new Date();
          now.setMinutes(now.getMinutes() + parseInt(configPedido?.previsaoMin || 0, 10));
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          pedidoData.horaPrevisao = `${hours}:${minutes}`;
          pedidoData.horaAgendada = null;
          pedidoData.dataHoraAgendada = null;

          setPedidoItens([]);
          setAgendadoPara(false);
          iniciarEnderecoCliente(decomporEnderecoCliente(pedidoData.enderecoCliente), clientes.find(c => c.id === pedidoData.clienteId));
          const versao = versaoClienteRef.current;
          setPedidoSel(pedidoData);
          setAutoOpenItemModal(false);
          await buscaClientes();

          if (!pedidoData.enderecoCliente && pedidoData.telefoneCliente) {
            const clienteByTelefone = await getClienteByTelefone(pedidoData.telefoneCliente);
            if (ativo && versao === versaoClienteRef.current && clienteByTelefone?.id) {
              const taxaBairro = TaxaEntregaBairro.encontrarPorEndereco(clienteByTelefone.pessoa?.endereco, taxasEntregaBairro);
              const camposCliente = enderecoPessoaParaCampos(clienteByTelefone.pessoa?.endereco);
              iniciarEnderecoCliente(camposCliente, clienteByTelefone);
              bairroEnderecoRef.current = taxaBairro?.id || null;
              setPedidoSel((prev) => ({
                ...prev,
                clienteId: clienteByTelefone.id,
                nomeCliente: clienteByTelefone.pessoa?.nome || prev.nomeCliente,
                telefoneCliente: clienteByTelefone.pessoa?.telefone?.numero || prev.telefoneCliente,
                enderecoCliente: formatEnderecoCliente(clienteByTelefone.pessoa?.endereco) || prev.enderecoCliente,
                taxaEntregaBairroId: taxaBairro?.id || prev.taxaEntregaBairroId,
                taxaEntrega: taxaBairro?.valor ?? prev.taxaEntrega,
              }));
            }
          }
        } else {
          const pedidoAgendado = Boolean(pedidoSel?.dataHoraAgendada || pedidoSel?.horaAgendada);
          setAgendadoPara(pedidoAgendado);
          iniciarEnderecoCliente(decomporEnderecoCliente(pedidoSel?.enderecoCliente), clientes.find(c => c.id === pedidoSel.clienteId));
          const versao = versaoClienteRef.current;

          if (pedidoSel?.dataHoraPrevisao || pedidoSel?.dataHoraAgendada) {
            setPedidoSel((prev) => ({
              ...prev,
              horaPrevisao: formatHoraPrevisao(prev?.dataHoraPrevisao) || prev?.horaPrevisao || '',
              horaAgendada: formatHoraPrevisao(prev?.dataHoraAgendada) || prev?.horaAgendada || '',
            }));
          }

          fetchPedidoItens(pedidoSel.id);
          setAutoOpenItemModal(false);
          await buscaClientes();
          if (!clienteEnderecoRef.current && pedidoSel.telefoneCliente) {
            const cliente = await getClienteByTelefone(pedidoSel.telefoneCliente);
            if (ativo && versao === versaoClienteRef.current) clienteEnderecoRef.current = cliente;
          }
        }
      }
    };
    carregarDados();
    return () => { ativo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || !pedidoAvulso || !produtoInicialPedido || autoOpenItemModal) return;
    if (pedidoSel?.id !== 0) return;
    if ((pedidoItens?.length || 0) > 0) return;

    setProdutoSelecionado(produtoInicialPedido);
    setPedidoItemEditando(null);
    setShowAddItemModal(true);
    setAutoOpenItemModal(true);
  }, [autoOpenItemModal, isOpen, pedidoAvulso, pedidoItens?.length, pedidoSel?.id, produtoInicialPedido]);

  const upsertPedidoItemLocal = (item) => {
    setPedidoItens(prev => {
      const arr = prev || [];
      const isNovo = !item.id || item.id === 0;

      // identifica chave (novo usa tempId)
      const key = isNovo ? item.tempId : item.id;

      const idx = arr.findIndex(x => {
        const xKey = (!x.id || x.id === 0) ? x.tempId : x.id;
        return xKey === key;
      });

      if (idx === -1) return [...arr, item];

      const novoArr = [...arr];
      novoArr[idx] = item;
      return novoArr;
    });

    // mantém sincronizado no pedidoSel também (pra quando concluir pedido novo)
    setPedidoSel(prev => ({
      ...prev,
      pedidoItens: (() => {
        const arr = (prev?.pedidoItens || []);
        const isNovo = !item.id || item.id === 0;
        const key = isNovo ? item.tempId : item.id;

        const idx = arr.findIndex(x => {
          const xKey = (!x.id || x.id === 0) ? x.tempId : x.id;
          return xKey === key;
        });

        if (idx === -1) return [...arr, item];

        const novoArr = [...arr];
        novoArr[idx] = item;
        return novoArr;
      })()
    }));
  };


  const tiposEntregaCombo = tiposEntrega.map((tipoEntrega) => ({
    value: tipoEntrega.id,
    label: tipoEntrega.descricao,
  }));

  const tipoEntregaSelecionado = tiposEntrega.find((tipo) => Number(tipo.id) === Number(pedidoSel?.tipoEntregaId))
    || (Number(pedidoSel?.tipoEntrega?.id) === Number(pedidoSel?.tipoEntregaId) ? pedidoSel.tipoEntrega : null);
  const temTaxaEntregaSelecionada = tipoEntregaSelecionado?.temTaxaEntrega === true;

  const statusCombo = statusPedidoOptions;

  const tipoPagamentoCombo = [
    { value: 1, label: "Dinheiro" },
    { value: 2, label: "Pix" },
    { value: 3, label: "Crédito" },
    { value: 4, label: "Débito" },
  ];

  const handleTipoEntregaChange = (e) => {
    const selectedTipoEntregaId = parseInt(e.target.value);
    const selected = tiposEntrega.find((tipo) => tipo.id === selectedTipoEntregaId);
    if (!selected) return;

    if (temTaxaEntregaSelecionada) bairroEnderecoRef.current = pedidoSel.taxaEntregaBairroId || null;
    const taxaBairro = taxasEntregaBairro.find((taxa) => Number(taxa.id) === Number(bairroEnderecoRef.current));

    setPedidoSel((pedidoAnterior) => ({
      ...pedidoAnterior,
      tipoEntregaId: selected.id,
      tipoEntrega: selected,
      enderecoCliente: selected.temTaxaEntrega ? comporEnderecoCliente(enderecoCampos) : null,
      taxaEntregaBairroId: selected.temTaxaEntrega && configModuloSel?.taxaEntregaBairro ? taxaBairro?.id || null : null,
      taxaEntrega: selected.temTaxaEntrega
        ? (configModuloSel?.taxaEntregaBairro
          ? parseNumeric(temTaxaEntregaSelecionada ? pedidoAnterior?.taxaEntrega : taxaBairro?.valor)
          : parseNumeric(taxaEntregaDefault?.valor))
        : 0,
      distancia: selected.temTaxaEntrega ? pedidoAnterior.distancia : null,
      latitude: selected.temTaxaEntrega ? pedidoAnterior.latitude : null,
      longitude: selected.temTaxaEntrega ? pedidoAnterior.longitude : null,
    }));

    setErros((prev) => ({ ...prev, tipoEntregaId: '', logradouro: '', numero: '', bairro: '', taxaEntregaBairroId: '', enderecoCliente: '' }));
  };

  const handleTaxaEntregaChange = (e) => {
    const rawValue = e.target.value;

    setPedidoSel({
      ...pedidoSel,
      taxaEntrega: rawValue,
    });
  };

  const handleAgendadoParaChange = (e) => {
    const marcado = e.target.checked;
    const horaAtual = agendadoPara ? pedidoSel?.horaAgendada : pedidoSel?.horaPrevisao;

    setAgendadoPara(marcado);
    setPedidoSel((prev) => ({
      ...prev,
      horaPrevisao: marcado ? null : horaAtual,
      dataHoraPrevisao: marcado ? null : prev?.dataHoraPrevisao,
      horaAgendada: marcado ? horaAtual : null,
      dataHoraAgendada: null,
    }));
    setErros((prev) => ({ ...prev, horaPrevisao: '', horaAgendada: '' }));
  };

  const handleClienteChange = (e) => {
    const nomeDigitado = e.target.value;

    const normalizeString = (str) =>
      str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const clienteEncontrado = clientes.find(
      (c) => normalizeString(c.pessoa.nome) === normalizeString(nomeDigitado)
    );

    if (clienteEncontrado) {
      const taxaBairro = TaxaEntregaBairro.encontrarPorEndereco(clienteEncontrado.pessoa.endereco, taxasEntregaBairro);
      const camposCliente = enderecoPessoaParaCampos(clienteEncontrado.pessoa.endereco);
      iniciarEnderecoCliente(camposCliente, clienteEncontrado);
      bairroEnderecoRef.current = taxaBairro?.id || null;
      setPedidoSel({
        ...pedidoSel,
        nomeCliente: clienteEncontrado.pessoa.nome,
        clienteId: clienteEncontrado.id,
        telefoneCliente: clienteEncontrado.pessoa.telefone?.numero || '',
        enderecoCliente: temTaxaEntregaSelecionada ? formatEnderecoCliente(clienteEncontrado.pessoa.endereco) : null,
        taxaEntregaBairroId: temTaxaEntregaSelecionada && configModuloSel?.taxaEntregaBairro ? taxaBairro?.id || null : null,
        taxaEntrega: temTaxaEntregaSelecionada ? (configModuloSel?.taxaEntregaBairro ? taxaBairro?.valor ?? pedidoSel.taxaEntrega : taxaEntregaDefault?.valor || 0) : 0,
      });
    } else {
      iniciarEnderecoCliente({ logradouro: '', numero: '', bairro: '', complemento: '' });
      bairroEnderecoRef.current = null;
      setPedidoSel({
        ...pedidoSel,
        nomeCliente: nomeDigitado,
        clienteId: null,
        telefoneCliente: '',
        enderecoCliente: '',
        taxaEntregaBairroId: null,
      });
    }

    setErros((prev) => ({ ...prev, nomeCliente: '' }));
  };

  const handleTelefoneBlur = async () => {
    const telefoneDigitado = pedidoSel?.telefoneCliente || '';
    const telefoneNumerico = telefoneDigitado.toString().replace(/\D/g, '');

    if (!telefoneNumerico) {
      setErros((prev) => ({ ...prev, telefoneCliente: '' }));
      return true;
    }

    if (telefoneNumerico.length < 10) {
      setErros((prev) => ({ ...prev, telefoneCliente: 'Telefone incompleto.' }));
      return false;
    }

    try {
      const result = await checkWhatsNumber(telefoneDigitado);

      if (!result.valido) {
        setErros((prev) => ({ ...prev, telefoneCliente: 'Telefone não localizado no WhatsApp.' }));
        return false;
      }

      setErros((prev) => ({ ...prev, telefoneCliente: '' }));
      return true;
    } catch (error) {
      console.error('Erro ao validar telefone no WhatsApp:', error);
      setErros((prev) => ({ ...prev, telefoneCliente: 'Não foi possível validar o telefone.' }));
      return false;
    }
  };

  const validateForm = () => {
    const novosErros = {};
    if (!pedidoSel.nomeCliente || pedidoSel.nomeCliente.trim() === '') novosErros.nomeCliente = 'Nome do cliente é obrigatório';
    if (!pedidoSel.statusPedido) novosErros.statusPedido = 'Status do pedido é obrigatório';
    if (!pedidoSel.tipoEntregaId) novosErros.tipoEntregaId = 'Tipo de entrega é obrigatório';
    if (!pedidoSel.formaPagId && pedidoComanda===false) novosErros.formaPagId = 'Forma de pagamento é obrigatória';
    if (agendadoPara && pedidoSel?.statusPedido!==1 && !pedidoSel.horaAgendada) novosErros.horaAgendada = 'Horário agendado é obrigatório';
    if (!agendadoPara && pedidoSel?.statusPedido!==1 && !pedidoSel.horaPrevisao) novosErros.horaPrevisao = 'Horário de previsão é obrigatório';
    if (temTaxaEntregaSelecionada) {
      const errosEndereco = Pedido.validarEnderecoEntrega({ ...enderecoCampos, taxaEntregaBairroId: pedidoSel.taxaEntregaBairroId }, configModuloSel?.taxaEntregaBairro);
      Object.assign(novosErros, errosEndereco);
      if (Object.keys(errosEndereco).length) {
        focarErroAoSalvarRef.current = false;
        setShowEnderecoModal(true);
      }
    }
    if (isEdit && !pedidoSel.formaPagId) delete novosErros.formaPagId;
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleConcluirPedido = async () => {
    if (pedidoGravadoRef.current || isSaving || aplicandoEnderecoRef.current) return;
    // 🔴 não deixa salvar sem item
    if ((pedidoItens?.length || 0) === 0) {
      showMessage("Adicione pelo menos 1 item antes de salvar.", "warning");
      return;
    }

    focarErroAoSalvarRef.current = true;
    if (!validateForm()) return;
    focarErroAoSalvarRef.current = false;

    setIsSaving(true);

    const telefoneValido = await handleTelefoneBlur();
    if (!telefoneValido) {
      setIsSaving(false);
      return;
    }
      
    setIsSaving(true);

    const pedidoSemNavegacoes = omitirCampos(pedidoSel, [
      "clienteApp",
      "formaPag",
      "tipoEntrega",
      "taxaEntregaBairro",
      "endereco",
      "usuario",
    ]);

    const pedidoPayload = {
      ...pedidoSemNavegacoes,
      enderecoCliente: temTaxaEntregaSelecionada ? comporEnderecoCliente(enderecoCampos) : null,
      taxaEntregaBairroId: temTaxaEntregaSelecionada ? pedidoSel.taxaEntregaBairroId : null,
      taxaEntrega: temTaxaEntregaSelecionada ? parseNumeric(pedidoSel.taxaEntrega) : 0,
      distancia: temTaxaEntregaSelecionada ? pedidoSel.distancia : null,
      latitude: temTaxaEntregaSelecionada ? pedidoSel.latitude : null,
      longitude: temTaxaEntregaSelecionada ? pedidoSel.longitude : null,
      valorItens: totais.subtotal,
      valorTotal: totais.total,
      valorAcrescimo: totais.acrescimo,
      valorDesconto: totais.desconto,
      pedidoItens: (pedidoItens || []).map(prepararPedidoItemPayload),
    };

    try {
      const pedidoId = Number(pedidoSel?.id || 0);
      const alterandoPedido = pedidoId > 0;
      const telefonePedidoAntesDeSalvar = pedidoPayload?.telefoneCliente || "";
      const pedidoTemTelefoneAntesDeSalvar = telefonePedidoAntesDeSalvar.toString().replace(/\D/g, '').length > 0;
      let enviarAlteracao = false;

      if (alterandoPedido && pedidoTemTelefoneAntesDeSalvar) {
        enviarAlteracao = await showYesNo("Deseja enviar a alteração do pedido no WhatsApp do cliente?");
      }

      const response =
        pedidoComanda && !alterandoPedido
          ? await salvarPedidoGarcom({
              pedido: {
                ...pedidoPayload,
                pedidoItens: (pedidoPayload.pedidoItens || pedidoItens || []).map((item) => ({
                  ...item,
                  enviarCozinha: true,
                })),
              },
              comandaId: pedidoPayload.comandaId,
            })
          : alterandoPedido
            ? await updatePedidoService(pedidoPayload)
            : await createPedido(pedidoPayload);

      const pedidoSalvo = response?.pedidoCozinha || response;
      pedidoGravadoRef.current = true;
      setPedidoSalvoResponse(response);
      setPedidoSel(pedidoSalvo);

      if (alterandoPedido && enviarAlteracao) {
        try {
          await enviarAlteracaoPedidoWhats(response.id);
          showAlert("Alteração do pedido enviada no WhatsApp do cliente.", "success");
        } catch (error) {
          console.error("Erro ao enviar alteração do pedido no WhatsApp:", error);
          showMessage("Pedido salvo, mas não foi possível enviar a alteração no WhatsApp.", "warning");
        }
      }

      onClose(response);

      if (configModuloSel.printPedidoAceito && pedidoSalvo?.id) {
        await printPedidoPDFById(pedidoSalvo.id);
        // printReciboPedido(pedidoSalvo);
      }
    } catch (error) {
      console.error("Erro ao gravar dados: ", error);
      showMessage("Erro ao gravar o pedido.", "error");
    } finally {
      setIsSaving(false);
    }
  };


  const handleDelete = async (pedidoItemId) => {
    const resposta = await showYesNo("Deseja excluir o item selecionado?");
    if (!resposta) return;

    if (!pedidoItemId.id || pedidoItemId.id === 0) {
      const novosItens = pedidoItens.filter(item => item.tempId !== pedidoItemId.tempId);
      setPedidoItens(novosItens);
      setPedidoSel({ ...pedidoSel, pedidoItens: novosItens });
    } else {
      const novosItens = await deletePedidoItem(pedidoItemId.id);
      setPedidoSel({ ...pedidoSel, pedidoItens: novosItens });
    }
  };


  const handleNovoItem = () => {
    let pedItem = new PedidoItem();
    pedItem = { pedidoId: pedidoSel.id };
    setPedidoItemSel(pedItem);    
  };

  const handleEditarItem = (itemSel) => {
    setPedidoItemEditando(itemSel);          // ✅ passa o item completo
    setProdutoSelecionado(itemSel.produto);  // ✅ modal usa produtoSel
    setShowAddItemModal(true);               // ✅ abre modal novo
  };


  const selectedCliente = pedidoSel.clienteId
    ? clientes.find(cliente => cliente.id === pedidoSel.clienteId)
    : null;

  // ✅ TOTAIS (itens + taxa)
  const totais = useMemo(() => {
    const subtotal = (pedidoItens || []).reduce((acc, it) => acc + (it.valorTotal || 0), 0);
    const taxa = parseNumeric(pedidoSel?.taxaEntrega);
    const acrescimo = Number(pedidoSel?.valorAcrescimo || 0);
    const desconto = Number(pedidoSel?.valorDesconto || 0);
    const cashBack = Number(pedidoSel?.valorCashBack || 0);
    const total = Math.max(subtotal + taxa + acrescimo - desconto, 0);
    const qtd = (pedidoItens || []).reduce((acc, it) => acc + (it.qtde || 0), 0);
    return { subtotal, taxa, acrescimo, desconto, cashBack, total, qtdItens: qtd, qtdLinhas: (pedidoItens || []).length };
  }, [pedidoItens, pedidoSel?.taxaEntrega, pedidoSel?.valorAcrescimo, pedidoSel?.valorDesconto, pedidoSel?.valorCashBack]);

  const handleAplicarAjusteValor = ({ valorAcrescimo, valorDesconto }) => {
    setPedidoSel((prev) => ({
      ...prev,
      valorAcrescimo: Number(valorAcrescimo || 0),
      valorDesconto: Number(valorDesconto || 0),
    }));
    setShowAjusteValorModal(false);
  };


  const podeIncluirItem = !pedidoAvulso || (pedidoItens?.length || 0) === 0;
  const temItens = (pedidoSel.id !== 0 || (pedidoItens?.length || 0) > 0);
  const numeroPedido = getNumeroPedido(pedidoSel, configModuloSel);

  const handleAddItem = async () => {
    if (pedidoAvulso && (pedidoItens?.length || 0) > 0) return;

    const produtoSel = await showProdutoSearch();
    if (produtoSel) {
      setPedidoItemEditando(null);      // ✅ é inclusão, não edição
      setProdutoSelecionado(produtoSel);
      setShowAddItemModal(true);
    }
  };

  const handleImprimirPedido = async () => {
    try {
      if (pedidoSel.id !== 0) {
        await printPedidoPDFById(pedidoSel.id);
        // const pedido = await getPedidoById(pedidoSel.id);
        // printReciboPedido(pedido);
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  };

  const getResumoVariacao = (pedidoItem) => {
    // tenta pegar de vários lugares (ajusta conforme teu modelo)
    const v =
      formatarVariacoes(pedidoItem) ||
      //pedidoItem?.produto?.variacao?.descricao ||
      pedidoItem?.variacaoDescricao ||
      "";

    const txt = String(v || "").trim();
    return txt ? txt : "";
  };

  const getResumoAdicionaisLista = (pedidoItem) => {
    const ads = pedidoItem?.pedidoItemAdicionais || [];
    if (!ads.length) return [];

    return ads
      .map(a => a?.adicional?.descricao || a?.adicionalDescricao || a?.descricao || "")
      .map(s => String(s || "").trim())
      .filter(Boolean);
  };

  // retorna uma lista de grupos: [{ nome: "Molhos", itens: ["1x Barbecue", "2x Maionese"] }]
  const getResumoConjuntosAgrupado = (pedidoItem) => {
    const cjs = pedidoItem?.pedidoItemConjuntos || [];
    if (!cjs.length) return [];

    const mapa = new Map();

    cjs.forEach(i => {
      const nome = (i?.conjuntoNome || i?.nomeConjunto || "Conjunto").trim();
      const itemNome = (i?.conjuntoItemNome || i?.descricao || i?.produto?.descricao || "Item").trim();
      const qtd = Number(i?.qtdItens || 0);

      if (!mapa.has(nome)) mapa.set(nome, []);
      mapa.get(nome).push(`${qtd}x ${itemNome}`);
    });

    return Array.from(mapa.entries()).map(([nome, itens]) => ({ nome, itens }));
  };

  const getObservacaoItem = (pedidoItem) => {
    const obs = (pedidoItem?.observacao || "").trim();
    if (!obs) return "";
    return obs;
  };

  const corStatusPedido = coresStatusPedido[Number(pedidoSel?.statusPedido)];
  const descricaoStatusPedido = getStatusPedidoDescricao(pedidoSel?.statusPedido);
  const dadosEndereco = { ...enderecoCampos, taxaEntregaBairroId: pedidoSel?.taxaEntregaBairroId, taxaEntrega: pedidoSel?.taxaEntrega };
  const resumoEndereco = comporEnderecoCliente(enderecoCampos);
  const enderecoIncompleto = Object.keys(Pedido.validarEnderecoEntrega(dadosEndereco, configModuloSel?.taxaEntregaBairro)).length > 0;
  const acaoEndereco = !resumoEndereco ? 'Adicionar endereço' : enderecoIncompleto ? 'Completar endereço' : 'Editar endereço';

  return (
    <ModalContainer show={isOpen} variant="cadastro" onHide={fecharPedido} largura="1080px" contentClassName="cadpedido-modal modal-operacional">
        <ModalHeader title={pedidoSel?.id === 0 ? "Cadastrar Novo Pedido" : `Alterar Pedido Nº ${numeroPedido}`} icon={FiClipboard} onHide={fecharPedido} closeDisabled={isApplyingEndereco} headerColors={headerColors}>
          {/* Linha 1: Status + Previsão */}
          <fieldset ref={cabecalhoFormularioRef} disabled={isSaving || isApplyingEndereco || !!pedidoSalvoResponse} className={`cadpedido-header-controls${pedidoAvulso ? ' sem-status' : ''}`}>
            {!pedidoAvulso && (
              <div className={`cadpedido-header-status ${corStatusPedido || ''}`.trim()} title={descricaoStatusPedido || undefined}>
                <Select
                  label="Status Pedido"
                  value={pedidoSel?.statusPedido || ''}
                  onChange={(e) => {
                    setPedidoSel({ ...pedidoSel, statusPedido: parseInt(e.target.value) });
                    setErros((prev) => ({ ...prev, statusPedido: '' }));
                  }}
                  options={statusCombo}
                  size="100%"
                  msgErro={erros.statusPedido}
                  hidden={pedidoAvulso}
                />
              </div>
            )}
            <div className="cadpedido-previsao">
              <Input
                label={agendadoPara ? "Agendado" : "Previsão"}
                value={agendadoPara ? pedidoSel?.horaAgendada : pedidoSel?.horaPrevisao}
                onChange={(e) => {
                  const campoHora = agendadoPara ? 'horaAgendada' : 'horaPrevisao';
                  setPedidoSel({ ...pedidoSel, [campoHora]: e.target.value });
                  setErros((prev) => ({ ...prev, [campoHora]: '' }));
                }}
                msgErro={agendadoPara ? erros.horaAgendada : erros.horaPrevisao}
                mask="99:99"
                size="80px"
              />
              {configModuloSel?.imprimePrevisao && (
                <InputCheck
                  id="agendadoPara"
                  label="Agendar"
                  checked={agendadoPara}
                  onChange={handleAgendadoParaChange}
                />
              )}
            </div>
          </fieldset>
        </ModalHeader>

        <ModalBody>
          <fieldset ref={formularioRef} disabled={isSaving || isApplyingEndereco || !!pedidoSalvoResponse} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
          {/* ✅ GRID RESPONSIVO: 2 cols / 1 col */}
          <div className="cadpedido-grid">
            {/* ESQUERDA: INPUTS */}
            <div className="cadpedido-col cadpedido-dados">

              {/* Linha 2: Cliente + Telefone */}
              <section className="cadpedido-secao" aria-label="Cliente">
              <h3 className="cadpedido-section-title"><FiUser aria-hidden="true" />Cliente</h3>
              <div className="cadpedido-row">
                <InputCliente
                  label="Cliente"
                  name="nomeCliente"
                  value={pedidoSel?.nomeCliente || ''}
                  size="100%"
                  onChange={handleClienteChange}
                  btnAdd={() => showClienteCad(selectedCliente)}
                  msgErro={erros.nomeCliente}
                />

                <Input
                  label="Telefone"
                  value={pedidoSel?.telefoneCliente || ''}
                  onChange={(e) => {
                    setPedidoSel({ ...pedidoSel, telefoneCliente: e.target.value });
                    setErros((prev) => ({ ...prev, telefoneCliente: '' }));
                  }}
                  onBlur={handleTelefoneBlur}
                  size="150px"
                  mask="(99) 9 9999-9999"
                  msgErro={erros.telefoneCliente}
                  hidden={pedidoComanda}
                />
              </div>
              </section>

              {/* Entrega */}
              {!pedidoComanda && (
              <section className="cadpedido-secao" aria-label="Entrega">
              <h3 className="cadpedido-section-title"><FiTruck aria-hidden="true" />Entrega</h3>
              <div className="cadpedido-row cadpedido-row-entrega">
                <Select
                  label="Tipo Entrega"
                  value={pedidoSel?.tipoEntregaId || ''}
                  onChange={handleTipoEntregaChange}
                  options={tiposEntregaCombo}
                  size="100%"
                  msgErro={erros.tipoEntregaId}
                  hidden={pedidoComanda}
                />

                {temTaxaEntregaSelecionada && (
                  <Input
                    label="Taxa entrega"
                    value={pedidoSel?.taxaEntrega ?? ""}
                    onChange={handleTaxaEntregaChange}
                    monetary
                    type="text"
                    placeholder="0,00"
                    size="95px"   // ✅ menor (era 180px)
                    msgErro={erros.tipoEntregaId}
                    hidden={pedidoComanda}
                  />
                )}
                {temTaxaEntregaSelecionada && (
                  <button type="button" className="btn btn-outline-secondary btn-sm cadpedido-endereco-editar" aria-label={acaoEndereco} title={acaoEndereco} onClick={() => setShowEnderecoModal(true)}>
                    {resumoEndereco ? <FiEdit2 aria-hidden="true" /> : <FiPlus aria-hidden="true" />}<span className="cadpedido-endereco-acao-texto">{acaoEndereco}</span>
                  </button>
                )}
              </div>

              {/* Endereço */}
              {temTaxaEntregaSelecionada && (
                <div className={`cadpedido-endereco${enderecoIncompleto ? ' cadpedido-endereco-incompleto' : ''}`}>
                  <div className="cadpedido-endereco-texto">
                    <FiMapPin aria-hidden="true" />
                    <div>
                      <p><span>Endereço: </span>{resumoEndereco ? <strong>{resumoEndereco}</strong> : <span className="cadpedido-endereco-vazio">Nenhum endereço informado.</span>}</p>
                      {enderecoIncompleto && <p className="cadpedido-endereco-aviso">Complete o endereço para realizar a entrega.</p>}
                    </div>
                  </div>
                </div>
              )}
              </section>
              )}

              {/* Pagamento + Total */}
              {!pedidoComanda && (
              <section className="cadpedido-secao" aria-label="Pagamento">
              <h3 className="cadpedido-section-title"><FiCreditCard aria-hidden="true" />Pagamento</h3>
              <div className="cadpedido-row cadpedido-row-pagamento">
                <Select
                  label="Forma de pagamento"
                  name="formaPagId"
                  options={tipoPagamentoCombo}
                  value={pedidoSel?.formaPagId || ''}
                  onChange={(e) => {
                    setPedidoSel({ ...pedidoSel, formaPagId: parseInt(e.target.value) });
                    setErros((prev) => ({ ...prev, formaPagId: '' }));
                  }}
                  size="100%"
                  msgErro={erros.formaPagId}
                  hidden={pedidoComanda}
                />

                {!pedidoComanda && (
                  <div className="cadpedido-ajuste-btn-wrap">
                    <button
                      type="button"
                      className="btn btn-outline-secondary modal-action cadpedido-ajuste-btn"
                      onClick={() => setShowAjusteValorModal(true)}
                    >
                      Ajustar valores
                      <FaDollarSign aria-hidden="true" />
                    </button>
                  </div>
                )}

              </div>
              </section>
              )}

              <section className="cadpedido-secao" aria-label="Observações">
              <h3 className="cadpedido-section-title"><FiMessageSquare aria-hidden="true" />Observações</h3>
              <div className="cadpedido-row-full">
                <Input
                  label={"Observação"}
                  labelHidden
                  value={pedidoSel?.observacao || ""}
                  placeholder={"Digite uma observação para o pedido"}
                  onChange={(e) => setPedidoSel({ ...pedidoSel, observacao: e.target.value })}
                  size="100%"
                  rows={2}
                />
              </div>
              </section>

              {/* Dica visual */}
              {/* {!pedidoComanda && (
                <div className="cadpedido-hint">
                  <span>📦 Delivery: confira taxa e endereço antes de concluir.</span>
                </div>
              )} */}
            </div>

            {/* DIREITA: ITENS + BOTÃO + TOTAIS */}
            <div className="cadpedido-col cadpedido-itens">
              <div className="cadpedido-itens-header">
                <div>
                  <div className="cadpedido-itens-title"><FiShoppingBag aria-hidden="true" />Itens do Pedido</div>
                  <div className="cadpedido-itens-subtitle">
                    {totais.qtdLinhas} item(ns) • {totais.qtdItens} unidade(s)
                  </div>
                </div>
                {podeIncluirItem && (
                  <ModalActionButton action="add" className="cadpedido-btn-add" onClick={handleAddItem}>Incluir Item</ModalActionButton>

                )}
              </div>

              {pedidoItens && pedidoItens.length > 0 ? (
                <div className="cadpedido-table-wrap">
                  <ModalTable className="cadpedido-table">
                    <thead>
                      <tr>
                        <th className="cadpedido-col-id" style={{ textAlign: "right" }}>Id</th>
                        <th>Descrição</th>
                        <th className="cadpedido-col-quantidade" style={{ textAlign: "right" }}>Qtd.</th>
                        <th className="cadpedido-col-valor" style={{ textAlign: "right" }}>Valor</th>
                        <th className="cadpedido-col-acoes" style={{ textAlign: "center" }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pedidoItens.map((pedidoItem) => {
                        const variacao = getResumoVariacao(pedidoItem);
                        const adicionais = getResumoAdicionaisLista(pedidoItem); // array
                        const conjuntos = getResumoConjuntosAgrupado(pedidoItem); // array de grupos
                        const observacao = getObservacaoItem(pedidoItem);

                        const temLinhaExtra =
                          !!variacao ||
                          adicionais.length > 0 ||
                          conjuntos.length > 0 ||
                          !!observacao;

                        return (
                          <React.Fragment key={pedidoItem.id || pedidoItem.tempId}>
                            {/* LINHA PRINCIPAL */}
                            <tr className="cadpedido-item-row">
                              <td className="cadpedido-col-id" style={{ textAlign: "right" }}>
                                <b>{pedidoItem.produto?.id || pedidoItem.produtoId}</b>
                              </td>
                              <td className="cadpedido-produto-nome">
                                {pedidoItem.produto?.descricao}
                              </td>

                              <td className="cadpedido-col-quantidade" style={{ textAlign: "right" }}><span className="cadpedido-quantidade">{pedidoItem.qtde}</span></td>
                              <td className="cadpedido-col-valor" style={{ textAlign: "right" }}>{formatCurrency(pedidoItem.valorTotal)}</td>

                              <td className="cadpedido-col-acoes">
                                <div className="cadpedido-actions">
                                  <button
                                    type="button"
                                    className="cadpedido-icon-btn cadpedido-icon-edit"
                                    title="Editar item"
                                    aria-label={`Editar ${pedidoItem.produto?.descricao || "item"}`}
                                    onClick={() => handleEditarItem(pedidoItem)}
                                  >
                                    <FaEdit aria-hidden="true" />
                                  </button>

                                  <button
                                    type="button"
                                    className="cadpedido-icon-btn cadpedido-icon-del"
                                    title="Excluir item"
                                    aria-label={`Excluir ${pedidoItem.produto?.descricao || "item"}`}
                                    onClick={() => handleDelete(pedidoItem)}
                                  >
                                    <FaTrashAlt aria-hidden="true" />
                                  </button>
                                </div>
                              </td>
                            </tr>

                            {/* LINHA EXTRA (tudo embaixo) */}
                            {temLinhaExtra && (
                              <tr className="cadpedido-det-row">
                                <td colSpan={5} className="cadpedido-det-cell">
                                  <div className="cadpedido-det-wrap">
                                    {variacao && (
                                      <div className="cadpedido-det-line">
                                        {variacao}
                                      </div>
                                    )}

                                    {conjuntos.length > 0 && (
                                      <div className="cadpedido-det-line">
                                        {conjuntos.map((g, idx) => (
                                          <span key={`${g.nome}-${idx}`}>
                                            <strong>{g.nome}:</strong> {g.itens.join(", ")}
                                            {idx < conjuntos.length - 1 ? " • " : ""}
                                          </span>
                                        ))}
                                      </div>
                                    )}

                                    {adicionais.length > 0 && (
                                      <div className="cadpedido-det-line">
                                        <strong>Adicionais:</strong> {adicionais.join(", ")}
                                      </div>
                                    )}

                                    {observacao && (
                                      <div className="cadpedido-det-line cadpedido-det-obs">
                                        <strong>Obs:</strong> {observacao}
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })}

                    </tbody>

                  </ModalTable>

                  {/* ✅ TOTAIS EMBAIXO */}
                  <div className="cadpedido-totais">
                    <div className="linha">
                      <span>Subtotal</span>
                      <b>{formatCurrency(totais.subtotal)}</b>
                    </div>

                    {!pedidoComanda && (
                      <div className="linha">
                        <span>Taxa entrega</span>
                        <b>{formatCurrency(totais.taxa)}</b>
                      </div>
                    )}

                    {totais.acrescimo > 0 && (
                      <div className="linha">
                        <span>Acréscimo</span>
                        <b>{formatCurrency(totais.acrescimo)}</b>
                      </div>
                    )}

                    {totais.desconto > 0 && (
                      <div className="linha">
                        <span>Desconto</span>
                        <b>- {formatCurrency(totais.desconto)}</b>
                      </div>
                    )}

                    {totais.cashBack > 0 && (
                      <div className="linha">
                        <span>CashBack</span>
                        <b>- {formatCurrency(totais.cashBack)}</b>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="cadpedido-empty">
                  <div className="cadpedido-empty-title">Nenhum item adicionado</div>
                  <div className="cadpedido-empty-subtitle">Clique em “Incluir Item” para começar.</div>

                  {temItens && (
                    <ModalActionButton action="add" className="cadpedido-btn-add" onClick={handleNovoItem}>Incluir Item</ModalActionButton>
                  )}
                </div>
              )}
            </div>
          </div>
          </fieldset>
        </ModalBody>

        <ModalFooter>
          <ModalActions>
            
            {/* ESQUERDA */}
            <div>
              {isEdit && (
                <ModalActionButton action="print" onClick={() => handleImprimirPedido()} // sua função de imprimir
                >Imprimir</ModalActionButton>
              )}
            </div>

            {/* DIREITA */}
            <div className="cadpedido-footer-actions">
              <div className="cadpedido-footer-total"><span>Total do pedido</span><output aria-label="Total do pedido" aria-live="polite" aria-atomic="true">{formatCurrency(totais.total)}</output></div>
              <ModalActionButton action="close" onClick={fecharPedido} disabled={isApplyingEndereco}>{pedidoSalvoResponse ? 'Fechar' : 'Cancelar'}</ModalActionButton>

              <ModalActionButton action="save" onClick={handleConcluirPedido} disabled={isSaving || isApplyingEndereco || !!pedidoSalvoResponse}>
                {isSaving ? "Aguarde..." : "Salvar"}
              </ModalActionButton>

            </div>
          </ModalActions>
        </ModalFooter>

        <AddItemPedidoModal
          show={showAddItemModal}
          headerColors={headerColors}
          onClose={() => {
            setShowAddItemModal(false);
            setProdutoSelecionado(null);
            setPedidoItemEditando(null);
          }}
          onSaved={upsertPedidoItemLocal}          // ✅ NOVO
          produtoInicial={produtoSelecionado}
          pedidoItemEditar={pedidoItemEditando}
          aplicarRegrasConjunto={!pedidoAvulso}
        />

        <AjusteValorPedidoModal
          show={showAjusteValorModal}
          headerColors={headerColors}
          onClose={() => setShowAjusteValorModal(false)}
          onApply={handleAplicarAjusteValor}
          valorAcrescimo={pedidoSel?.valorAcrescimo || 0}
          valorDesconto={pedidoSel?.valorDesconto || 0}
        />

        <EnderecoPedidoModal
          show={isOpen && showEnderecoModal}
          headerColors={headerColors}
          dados={dadosEndereco}
          errosIniciais={{ logradouro: erros.logradouro, numero: erros.numero, bairro: erros.bairro, taxaEntregaBairroId: erros.taxaEntregaBairroId }}
          onClose={fecharEndereco}
          onApply={handleAplicarEndereco}
          isApplying={isApplyingEndereco}
          erroAplicacao={erroAplicacaoEndereco}
        />


    </ModalContainer>
  );
}

export default CadPedido;
